import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'UniformAuthService',
    controller: 'UserRoleInfo'
}
const methods = [
    'AddItem',
    'AddItems',
    'UpdateItem',
    'DelItem',
    'GetItemById',
    'GetItemPagingList',
    'GetAllItems',
    'GetByUserId',
    'DeleteByUserId',
    'GetRoleIdsByUserId',
    'InsertItemList'
]

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
}

const UserRoleApi = ZJApi.defineNewApi('UserRoleApi', factory)

export default UserRoleApi